require('./lib/messager.js');


var Messager = window.Messager;
var tmp = Messager.prototype.post;
Messager.prototype.post = function (msg, target) {
    if (typeof msg !== 'string') {
        throw 'not string.'
    }
    tmp.call(this, msg, target);
};


(function () {
    var storage = {};

    var fnsMap = {};

    var fnGetMessager = function (domain, fn) {
        var fnCreateIframe = function (domain) {
            var protocol = window.location.protocol;
            var iframe = window.document.createElement('iframe');
            iframe.src = protocol + '//' + domain + '/crossdomain.html';
            iframe.style.display = 'none';
            window.document.body.appendChild(iframe);

            return iframe;
        };

        var messager = storage[domain];
        var frame;
        if (!messager) {
            frame = fnCreateIframe(domain);
            messager = new Messager("changyan", frame.contentWindow, 'parent');
            messager.ready = false;
            messager.readyFns = [ fn ];
            messager.listen(function(msg){
                if (msg === '[[ready]]') {
                    messager.ready = true;
                    (function () {
                        var i, fn;
                        for (i = 0; i < messager.readyFns.length; i++) {
                            fn = messager.readyFns[i];
                            fn && fn(messager);
                        }
                    }());
                    return;
                }
                
                msg = msg.split(',');

                fnsMap[msg[0]] && fnsMap[msg[0]](decodeURIComponent(msg[1]));
            });
            storage[domain] = messager;
        } else {
            if (!messager.ready) {
                messager.readyFns.push(fn);
            } else {
                fn && fn(messager);
            }
        }
    };

    var fnEval = function (domain, code) {
        fnGetMessager(domain, function (messager) {
            var msg = [
                'EVAL',
                code,
            ].join(',');

            messager.post(msg, 'frame');
        });
    };
    
    var fnPost = function (url, data, fn) {
        var domain = url.match(/:\/\/(.*?)\//)[1];
        fnGetMessager(domain, function (messager) {
            var msg = [
                'POST',
                url,
                data
            ].join(',');

            messager.post(msg, 'frame', function (msg) {
                fn && fn(msg);
            });
        });
    };
    
    var fnGet = function (url, data, fn) {
        var domain = url.match(/:\/\/(.*?)\//)[1];
        fnGetMessager(domain, function (messager) {
            var msg = [
                'GET',
                url,
                data
            ].join(',');

            messager.post(msg, 'frame', function (msg) {
                fn && fn(msg);
            });
        });
    };
    
    var tmp = Messager.prototype.post;
    Messager.prototype.post = function (msg, target, fn) {
        var key = 'key-' + (+new Date()) + window.Math.random().toFixed(15);
        msg = key + ',' + msg;
        fnsMap[key] = fn;
        tmp.call(this, msg, target);
    };

    var fnAjax = function (url, method, headers, body, credentials, complete) {
        if (method.toUpperCase() === 'POST') {
            fnPost(url, body, function (xhr) {
                complete(JSON.parse(xhr).xhr);
            });
        } else {
            fnGet(url, {}, function (xhr) {
                complete(JSON.parse(xhr).xhr);
            });
        }
    };

    exports.ajax = fnAjax;
}());



//////////////////
// WEBPACK FOOTER
// ./~/lib-request/src/request-iframe.js
// module id = 132
// module chunks = 17